import { redirect } from '@tanstack/react-router';
import { safeGetItem } from '@/utils/storage/storageUtils';
import { SELECTED_HOUSE_PUBLIC_ID_KEY } from '@/utils/storage/constants';

/** @deprecated Redirects to /property/:publicId — kept for backward compatibility */
export const Route = createFileRoute({
	beforeLoad: () => {
		const publicId = safeGetItem(SELECTED_HOUSE_PUBLIC_ID_KEY);
		throw redirect({
			to: publicId ? `/property/${publicId}` : '/properties',
			replace: true,
		} as never);
	},
});
